import React from 'react';
import { useReveal } from '../lib/useReveal';
const ITEMS = ['Querés aprender Biodescodificación desde cero', 'Buscás comprender el origen emocional de los síntomas', 'Te interesa el desarrollo personal', 'Querés incorporar nuevas herramientas profesionales', 'Valorás estudiar a tu ritmo', 'Buscás una formación clara, organizada y práctica'];
export function AudienceSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#f9f4e8] py-5 md:py-10 px-5 sm:px-6 border-t border-[#2d3f2a]/5" data-id="element-17">
      <div className="container mx-auto max-w-3xl" data-id="element-18">
        <div ref={ref} className={`reveal ${vis ? 'is-visible' : ''}`} data-id="element-19">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#1e3a1e] text-center mb-6" data-id="element-20">
            Esta formación es para vos si…
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-21">
            {ITEMS.map((item, i) => <div key={i} className="flex items-start gap-3 bg-[#ffffff] border border-[#2d3f2a]/20 rounded-xl p-4 shadow-sm" data-id="element-22">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#5a6b3f]/20 border border-[#5a6b3f]/40 flex items-center justify-center mt-0.5" data-id="element-23">
                  <span className="text-[#1e3a1e] text-sm font-bold" data-id="element-24">✓</span>
                </div>
                <p className="text-[#1e3a1e] text-sm sm:text-base font-medium leading-snug" data-id="element-25">
                  {item}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}